import React from 'react';
import './AdminForm.css';
import './SocialLinksEditor.css';

const SocialLinksEditor = ({ links, onFormChange }) => {

    const handleLinkChange = (id, field, value) => {
        const updatedLinks = (links || []).map(link => 
            link.id === id ? { ...link, [field]: value } : link
        );
        onFormChange('siteMeta.socialLinks', updatedLinks);
    };

    /*const handleDelete = (id) => {
        if (!window.confirm("Biztosan törölni szeretnéd ezt a linket?")) return;
        const updatedLinks = (links || []).filter(link => link.id !== id);
        onFormChange('siteMeta.socialLinks', updatedLinks);
    };

    const handleAddNew = () => {
        const newLink = {
            id: `social-${Date.now()}`,
            platform: "facebook",
            url: "",
            enabled: true
        };
        const currentLinks = links || [];
        onFormChange('siteMeta.socialLinks', [...currentLinks, newLink]);
    };*/

    return (
        <div className="editor-card p-10">
            <h3>Közösségi Média Linkek</h3>
            <p className="page-description">Itt adhatod meg a láblécben megjelenő linkeket. A sorrend a listában elfoglalt helyük szerint alakul.</p>
            
            <div className="social-links-list">
                {(links || []).map((link) => (
                    <div key={link.id} className="social-link-item">
                        {/* A drag handle helyett egy sima div vagy span */}
                        <div className="item-icon"></div>
                        <select 
                            value={link.platform} 
                            onChange={(e) => handleLinkChange(link.id, 'platform', e.target.value)}
                        >
                            <option value="facebook">Facebook</option>
                            <option value="x">X (Twitter)</option>
                            <option value="instagram">Instagram</option>
                            <option value="tiktok">TikTok</option>
                            {/* Ide a jövőben vehetsz fel új platformokat */}
                        </select>
                        <input 
                            type="text" 
                            placeholder="https://..." 
                            value={link.url}
                            onChange={(e) => handleLinkChange(link.id, 'url', e.target.value)}
                        />
                        <label className="switch">
                            <input 
                                type="checkbox" 
                                checked={link.enabled}
                                onChange={(e) => handleLinkChange(link.id, 'enabled', e.target.checked)}
                            />
                            <span className="slider"></span>
                        </label>
                        {/*<button onClick={() => handleDelete(link.id)} className="action-button delete small">Törlés</button>*/}
                    </div>
                ))}
            </div>

            {/*<div className="toolbar">
                <button onClick={handleAddNew} className="add-new-button">Új Link Hozzáadása</button>
            </div>*/}
        </div>
    );
};

export default SocialLinksEditor;